module.exports = __webpack_public_path__ + "static/media/YB5M13_4.f17ecb1b.jpg";